module.exports = __webpack_public_path__ + "static/media/logo.5264a854.png";